<template>
  <div class="coverShow" v-show="viseable">
    <div class="container-gj" @click="cancelClick">
      <div class="container-gd" @click.stop>
        <div class="question-theme-page">
          <!-- 内容区域 -->
          <div class="content">
            <!-- 封面图预览区域 -->
            <div class="cover-preview-section">
              <!-- 封面图开关 -->
              <div class="cover-switch-section">
                <span class="switch-label">同步为分享封面</span>
                <el-switch
                  v-model="ifSyncCoverToShare"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6"
                  :active-value="'1'"
                  :inactive-value="'0'"
                >
                </el-switch>
              </div>
              <div class="cover-preview">
                <img
                  v-if="mediaType === 'image'"
                  :src="coverUrl"
                  class="cover-image"
                />
                <video
                  v-else
                  :src="coverUrl"
                  class="cover-video"
                  controls
                ></video>
              </div>
              <!-- 更换封面按钮 -->
              <button class="change-cover-btn" @click="handleChangeCover">
                更换封面
              </button>

              <!-- 尺寸比例提示 -->
              <span class="size-hint"
                >*尺寸比例：宽5比4，建议宽度1500px，高度1200px。</span
              >
            </div>

            <!-- 上传按钮区域 -->
            <div class="upload-buttons">
              <button
                class="upload-btn upload-img-btn"
                @click="handleUploadImage"
              >
                <img
                  src="https://ossfastmake.mustke.com/wenjuan/tupian/02-1769655720313.svg"
                  class="upload-btn-icon"
                />
                <span class="upload-btn-text">上传自定义图片</span>
              </button>
              <button
                class="upload-btn upload-video-btn"
                @click="handleUploadVideo"
              >
                <img
                  src="https://ossfastmake.mustke.com/wenjuan/tupian/01-1769655747907.svg"
                  class="upload-btn-icon"
                />
                <span class="upload-btn-text">上传视频</span>
              </button>
            </div>
          </div>

          <!-- 底部保存按钮 -->
          <div class="bottom-save-section">
            <button class="save-button" @click="handleSave">保存</button>
          </div>

          <!-- 封面图选择弹窗 -->
          <div
            v-if="showCoverImage"
            class="modal-overlay"
            @click="showCoverImage = false"
          >
            <div class="modal-content" @click.stop>
              <div class="header-view">
                <span
                  style="
                    font-size: 18px;
                    font-weight: 600;
                    color: #2b2f36;
                    line-height: 24px;
                  "
                  >封面图设置</span
                >
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
                  @click="showCoverImage = false"
                  style="
                    width: 13px;
                    height: 13px;
                    margin-right: 6px;
                    cursor: pointer;
                  "
                />
              </div>
              <div style="padding: 0 10px; box-sizing: border-box">
                <div
                  style="width: 100%; height: 1px; background: #e7e7e7"
                ></div>
              </div>
              <div class="search-section">
                <div class="search-input-wrapper">
                  <img
                    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%238E89AA' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'%3E%3C/line%3E%3C/svg%3E"
                    class="search-icon"
                  />
                  <input
                    type="text"
                    v-model="searchKeywords"
                    placeholder="请搜索场景如学校、市场、教育"
                    class="search-input"
                  />
                  <div class="search-btn" @click="onSearch">
                    <img
                      src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='8'%3E%3C/circle%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'%3E%3C/line%3E%3C/svg%3E"
                      class="search-icon-white"
                    />
                  </div>
                </div>
              </div>
              <div v-if="!searchBoolean" class="tabs-container">
                <div class="tabs">
                  <div
                    v-for="(tab, index) in tabList"
                    :key="index"
                    class="tab-item"
                    :class="{ active: current === index }"
                    @click="tabClick(index)"
                  >
                    {{ tab.categoryName }}
                  </div>
                </div>
                <div
                  class="tab-line"
                  :style="{
                    left: tabLineLeft + 'px',
                    width: tabLineWidth + 'px',
                  }"
                ></div>
              </div>
              <div class="body-view" style="overflow-y: auto">
                <div class="image-container">
                  <div
                    v-for="(image, index) in imageList"
                    :key="index"
                    @click="imageClick(index)"
                    style="position: relative; cursor: pointer"
                  >
                    <img :src="image.coverUrl" style="width: 100%" />
                    <div
                      v-if="selectIndex === index"
                      style="position: absolute; right: 0; bottom: 0"
                    >
                      <img
                        src="https://ossfastmake.mustke.com/wenjuan/tupian/1-1769412983726.svg"
                        style="width: 43.5px; height: 22.5px; z-index: 10"
                      />
                    </div>
                  </div>
                  <div class="noData" v-if="imageList.length === 0">
                    <img
                      class="icon"
                      :src="
                        FILE_URL + '/wenjuan/tupian/nothing-1741240452308.png'
                      "
                    />
                    暂无相关数据
                  </div>
                </div>
              </div>
              <div class="tips-view">
                <span>更改封面内文字，请</span>
                <span class="service-text">联系客服</span>
                <span>免费帮您制作好看的活动。</span>
              </div>
              <div class="button-container">
                <button class="service-btn" @click="handleServiceClick">
                  联系客服
                </button>
                <button class="choose-btn" @click="handleChooseClick">
                  保存
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CropImage
      :cropWidth="500"
      :cropHeight="400"
      :imageUrl="tempFilePath"
      @crop-success="handleCropSuccess"
    />
  </div>
</template>

<script>
import { getCoverCategoryList, getCoverImageList } from "@/api/index.js";
// import { baseURL } from "@/baseUrl";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
import CropImage from "@/components/CropImage/index.vue";
import { base64ToFile } from "@/utils/fileConvert";

// import { FILE_URL, IMAGE_URL } from "@/baseUrl.js";
export default {
  name: "SetCoverImage",
  components: {
    CropImage,
  },
  props: {
    param: {
      type: Object,
      default: () => {},
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      coverUrl: "",
      showCoverImage: false,
      uuid: "",
      tabList: [],
      imageList: [],
      selectIndex: null,
      ifSyncCoverToShare: "0", // 是否同步封面图到分享 0不设置 1设置
      tempFilePath: "",
      kspImgWidth: 350,
      kspImgHeight: 280,
      currentFile: null,
      cropStartX: 0,
      cropStartY: 0,
      cropWidth: 500,
      cropHeight: 400,
      isDragging: false,
      currentFile: null,
      mediaType: "image",
      questionnaireType: "",
      searchKeywords: "",
      current: 0,
      searchBoolean: false,
      tabLineLeft: 0,
      tabLineWidth: 0,
      viseable: false,
      loading: null,
    };
  },
  mounted() {
    // if (this.param) {
    //   try {
    //     const params = JSON.parse(decodeURIComponent(this.param));
    //     this.coverUrl = params.coverUrl || "";
    //     this.ifSyncCoverToShare = params.ifSyncCoverToShare || "0";
    //     this.questionnaireType = params.questionnaireType || "";

    //     if (this.coverUrl) {
    //       const type = this.coverUrl.split("?")[0].split(".")[
    //         this.coverUrl.split("?")[0].split(".").length - 1
    //       ];
    //       if (type === "mp4" || type === "avi" || type === "mov") {
    //         this.mediaType = "video";
    //       }
    //     }
    //   } catch (error) {
    //     console.error("解析参数失败:", error);
    //   }
    // }
    this.getCategory();
  },
  watch: {
    showDialog(newVal) {
      console.log("iei21u92r2109ry29r0y2r021yr1209ry021");

      this.viseable = newVal;
    },
    param(newVal) {
      console.log("param发iO记hog合格hi哦个hi哦工会哦IG和", newVal);
      if (newVal) {
        try {
          //   const params = JSON.parse(decodeURIComponent(newVal));
          this.coverUrl = newVal.coverUrl;
          this.ifSyncCoverToShare = newVal.ifSyncCoverToShare;
          this.questionnaireType = newVal.questionnaireType;
          this.uuid = newVal.uuid;
          if (this.coverUrl) {
            const type = this.coverUrl.split("?")[0].split(".")[
              this.coverUrl.split("?")[0].split(".").length - 1
            ];
            if (type === "mp4" || type === "avi" || type === "mov") {
              this.mediaType = "video";
            }
          }
        } catch (error) {
          console.error("解析参数失败:", error);
        }
      }
    },
  },
  methods: {
    getCategory() {
      getCoverCategoryList({
        activityType: this.questionnaireType,
      })
        .then((res) => {
          console.log(res, "封面分类列表");
          this.tabList = res.data || [];
          if (this.tabList.length > 0) {
            this.getImageList(this.tabList[0].id);
            this.$nextTick(() => {
              this.updateTabLine();
            });
          }
        })
        .catch((err) => {
          console.log(err, "封面分类列表失败");
        });
    },

    onSearch() {
      this.getImageList("");
    },
    getImageList(id) {
      console.log("id", id);
      if (!id && this.searchKeywords === "") {
        id = this.tabList[0].id;
      }
      getCoverImageList({
        categoryId: id,
        keywords: this.searchKeywords,
      })
        .then((res) => {
          console.log(res, "封面图片列表");
          console.log("searchKeywords", this.searchKeywords);
          if (this.searchKeywords != "" && res.rows.length === 0) {
            this.searchBoolean = true;
          } else {
            this.searchBoolean = false;
          }
          this.imageList = res.rows || [];
        })
        .catch((err) => {
          console.log(err, "封面图片列表失败");
        });
    },
    handleChangeCover() {
      console.log("更换封面");
      this.showCoverImage = true;
    },
    handleUploadImage() {
      console.log("上传自定义图片");
      // 创建文件输入框
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          this.currentFile = file;
          this.tempFilePath = URL.createObjectURL(file);
        }
      };
      input.click();
    },
    handleUploadVideo() {
      console.log("上传视频");
      // 创建文件输入框
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "video/*";
      input.onchange = (e) => {
        const file = e.target.files[0];
        // 视频大小不能超过50MB
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error("视频大小不能超过50MB");
          return;
        }
        // 生成唯一文件名，避免直接修改 File 对象的只读属性
        const timestamp = Date.now();
        const randomStr = Math.random().toString(36).substr(2, 6);
        const fileExtension = file.name.split(".").pop() || "mp4";
        const fileName = `video_${timestamp}_${randomStr}.${fileExtension}`;
        // 创建新的 File 对象
        const newFile = new File([file], fileName, { type: file.type });

        if (newFile) {
          this.loading = this.$loading({
            lock: true,
            text: "上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          // 这里需要实现文件上传功能
          setTimeout(() => {
            const formData = new FormData();
            formData.append("uuid", this.uuid);
            formData.append("file", newFile);
            axios
              .post(baseURL + "/PCwj/file/uploads", formData, {
                headers: {
                  "Content-Type": "multipart/form-data", // 必须设置
                  token: localStorage.getItem("token"),
                },
              })
              .then((res) => {
                console.log("response.data.urls", res.data.code, res.data.urls);

                if (res.data.code === 200) {
                  this.coverUrl = res.data.urls;
                  this.mediaType = "video";

                  this.$message.success("上传成功");
                } else {
                  this.$message.error(res.data.msg || "上传失败");
                }
                this.loading.close();
              })
              .catch((error) => {
                this.$message.error("上传失败");
                this.loading.close();
              });
          }, 1000);
        }
      };
      input.click();
    },
    handleSave() {
      this.$emit("setCoverImage", {
        coverUrl: this.coverUrl,
        ifSyncCoverToShare: this.ifSyncCoverToShare,
      });
    },
    handleServiceClick() {
      const chatUrl = "https://work.weixin.qq.com/kfid/kfc0cc2805fe313bc18";
      window.open(chatUrl, "_blank");
    },
    handleChooseClick() {
      if (this.selectIndex !== null) {
        this.coverUrl = this.imageList[this.selectIndex].coverUrl;
        const type = this.coverUrl.split("?")[0].split(".")[
          this.coverUrl.split("?")[0].split(".").length - 1
        ];
        if (type === "mp4" || type === "avi" || type === "mov") {
          this.mediaType = "video";
        } else {
          this.mediaType = "image";
        }
        this.showCoverImage = false;
      }
    },
    imageClick(index) {
      console.log(index, "点击了图片");
      this.selectIndex = index;
    },
    tabClick(index) {
      console.log(index, "点击了tab");
      this.current = index;
      this.getImageList(this.tabList[index].id);
      this.selectIndex = null;
      this.updateTabLine();
    },
    updateTabLine() {
      this.$nextTick(() => {
        const tabItems = document.querySelectorAll(".tab-item");
        if (tabItems.length > 0 && tabItems[this.current]) {
          const tabItem = tabItems[this.current];
          this.tabLineLeft = tabItem.offsetLeft;
          this.tabLineWidth = tabItem.offsetWidth;
        }
      });
    },
    handleSwitchChange() {
      this.ifSyncCoverToShare = this.ifSyncCoverToShare === "0" ? "1" : "0";
    },
    cancelClick() {
      this.$emit("close");
    },
    handleCropSuccess(image) {
      const file = base64ToFile(image.base64, this.currentFile.name);
      const formData = new FormData();
      formData.append("uuid", this.uuid);
      formData.append("file", file);

      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log("response.data.urls", res.data.code, res.data.urls);

          if (res.data.code === 200) {
            this.coverUrl = res.data.urls;
            this.mediaType = "image";
            this.tempFilePath = "";
            this.currentFile = null;
            this.$message.success("上传成功");
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.$message.error("上传失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 100;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 600px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 100;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

// .question-theme-page {
//   background-color: #ffffff;
//   min-height: 100vh;
// }

/* 内容区域 */
.content {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}

/* 封面图开关 */
.cover-switch-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.switch-label {
  font-size: 16px;
  color: #333333;
}

/* 封面图预览区域 */
.cover-preview-section {
  border: 3px dashed rgba(80, 88, 238, 0.3);
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 15px;
  box-sizing: border-box;

  .cover-image {
    width: 100%;
    border-radius: 10px;
  }

  .cover-video {
    width: 100%;
    border-radius: 10px;
  }
}

.cover-preview {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}

.change-cover-btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  background-color: #ffffff;
  color: #007aff;
  font-size: 14px;
  border: 1px solid #007aff;
  border-radius: 15px;
  margin: 0 auto;
  display: block;
  cursor: pointer;
}

.size-hint {
  display: block;
  font-size: 12px;
  color: #999999;
  text-align: center;
  margin-top: 10px;
}

/* 上传按钮区域 */
.upload-buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.upload-btn {
  flex: 1;
  height: 40px;
  line-height: 40px;
  background-color: #ffffff;
  color: #007aff;
  font-size: 14px;
  border: 1px solid #007aff;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  cursor: pointer;
}

.upload-btn-icon {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.upload-btn-text {
  font-size: 14px;
  color: #007aff;
}

/* 底部保存按钮 */
.bottom-save-section {
  padding: 0 15px 20px;
}

.save-button {
  width: 100%;
  height: 45px;
  line-height: 45px;
  background-color: #007aff;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 22.5px;
  border: none;
  cursor: pointer;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  width: 90%;
  max-width: 600px;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.body-view {
  width: 100%;
  max-height: 400px;
  margin-top: 10px;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
  flex: 1;
}

.header-view {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}

.header-view img {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
}

.image-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  padding: 10px 0;

  .noData {
    padding: 32px 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 12px;
    color: #969798;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .icon {
      width: 72.5px;
      height: 72.5px;
      margin-bottom: 10px;
    }
  }
}

.search-section {
  display: flex;
  align-items: center;
  padding: 0 10px;

  .search-input-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 20px;
    height: 36px;
    border: 1px solid #e8e8e8;
    padding: 0 4px 0 12px;
    box-sizing: border-box;
    margin-top: 10px;
  }

  .search-input {
    flex: 1;
    font-size: 14px;
    color: #333333;
    border: none;
    outline: none;
    background: transparent;
  }

  .search-btn {
    width: 47px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1877ff;
    border-radius: 14px;
    cursor: pointer;
  }

  .search-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }

  .search-icon-white {
    width: 18px;
    height: 18px;
  }
}

.tips-view {
  display: flex;
  align-items: center;
  margin-left: 12.5px;
  padding: 10px 0;
  margin: 0 auto;

  span {
    font-size: 13px;
    color: #636a84;
  }

  .service-text {
    font-size: 13px;
    color: #1877ff;
    border-bottom: 1px solid #1877ff;
    margin: 0 5px;
    cursor: pointer;
  }
}

.button-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  // margin: 20px 10px;
  margin-bottom: 20px;

  .service-btn {
    width: 126px;
    height: 42px;
    color: #1877ff;
    border: 1px solid #1877ff;
    font-size: 15px;
    font-weight: 600;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: white;
  }

  .choose-btn {
    width: 187px;
    height: 42px;
    background-color: #1877ff;
    color: #fff;
    border: 1px solid #1877ff;
    font-size: 15px;
    font-weight: 600;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

/* 标签页样式 */
.tabs-container {
  position: relative;
  border-bottom: 1px solid #e7e7e7;
}

.tabs {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
}

.tab-item {
  padding: 0 15px;
  height: 47px;
  line-height: 47px;
  font-size: 16px;
  color: #4c4a56;
  cursor: pointer;
  position: relative;
}

.tab-item.active {
  color: #3a60ff;
  font-weight: 600;
}

.tab-line {
  position: absolute;
  bottom: 0;
  height: 2px;
  background-color: #3a60ff;
  transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/SetCoverImage/index.vue